import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService, CommonPortalUrlService, UrlParamService } from 'gast-portal-ng';
import { TranslationService } from 'gast-common-ng';
var AuthGuard = /** @class */ (function () {
    function AuthGuard(http, authService, commonPortalUrlService, translationService, router, route, urlParamService) {
        this.http = http;
        this.authService = authService;
        this.commonPortalUrlService = commonPortalUrlService;
        this.translationService = translationService;
        this.router = router;
        this.route = route;
        this.urlParamService = urlParamService;
    }
    AuthGuard.prototype.canActivate = function (routeSnapshot) {
        var _this = this;
        this.urlParamService.saveSessionFromParamAndRemoveParam(routeSnapshot.queryParamMap);
        return this.http.get(this.commonPortalUrlService.getUserInfo(), { withCredentials: true }).pipe(map(function (response) {
            if (response && response.name) {
                _this.authService.saveUserObjectInStorage(response.name, response.principal.longusername);
                return true;
            }
            else {
                return _this.handleNotLoggedIn();
            }
        }), catchError(function (err) {
            console.log('failed to retrieve user-info', err);
            return of(false);
        }));
    };
    AuthGuard.prototype.handleNotLoggedIn = function () {
        this.authService.saveUserObjectInStorage(null, null);
        this.router.navigate(['/course'], {
            relativeTo: this.route,
            queryParams: { lang: this.translationService.getCurrentLanguageCode().toLocaleLowerCase() },
        });
        return false;
    };
    return AuthGuard;
}());
export { AuthGuard };
